import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { SupplierLayouts } from 'src/layouts';
import { ProtectedLayout } from 'src/layouts/shared/ProtectedLayout';
import { PublicContractsLayout } from 'src/layouts/shared/PublicContractsLayout';

import { SplashScreen } from 'src/components/LoadingScreen';

import { paths } from '../paths';

const ContractsDashboard = lazy(() => import('src/pages/contracts'));
const ViewSingleContractDashboard = lazy(
  () => import('src/pages/contracts/SingleContract/ViewSingleContract')
);
const ContractsOpenForTender = lazy(
  () => import('src/pages/procurer/contracts/ContractsOpenForTender')
);
const SingleContractOpenForTender = lazy(
  () => import('src/pages/procurer/contracts/ContractsOpenForTender/SingleContractOpenForTender')
);
const AwardContractPage = lazy(() => import('src/pages/procurer/contracts/AwardContract'));
const FinalizeAwardedContractPage = lazy(
  () => import('src/pages/procurer/contracts/FinalizeAwardedContract')
);

const NewReportPage = lazy(() => import('src/pages/supplier/SubmitReport'));

export const dashboardRoutes: RouteObject[] = [
  {
    path: '/dashboard',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <PublicContractsLayout>
          <Outlet />
        </PublicContractsLayout>
      </Suspense>
    ),
    children: [
      {
        path: 'contracts',
        element: <ProtectedLayout allowedRoles={['PROCURER', 'ADMIN', 'SUPPLIER']} />,
        children: [
          {
            path: '',
            element: <ContractsDashboard />,
          },
          {
            path: 'open-for-tender',
            element: <ContractsOpenForTender />,
          },
          {
            path: ':contractId/award-contract',
            element: <AwardContractPage />,
          },
          {
            path: ':contractId/finalize-awarded-contract',
            element: <FinalizeAwardedContractPage />,
          },
          {
            path: 'open-for-tender/:id',
            element: <SingleContractOpenForTender />,
          },
          {
            path: ':contractId',
            element: <ViewSingleContractDashboard />,
          },
        ],
      },
      {
        path: 'public/:procurerId/contracts',
        element: <ContractsDashboard isPublic />,
      },
    ],
  },
  {
    path: paths.supplier.submitReport,
    element: (
      <Suspense fallback={<SplashScreen />}>
        <ProtectedLayout allowedRoles={['SUPPLIER']} />
      </Suspense>
    ),
    children: [
      {
        path: '',
        element: (
          <SupplierLayouts.SetupLayout>
            <NewReportPage />
          </SupplierLayouts.SetupLayout>
        ),
      },
    ],
  },
];
